import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ConstructorContent as SchemaConstructorContent } from '../schemas/ConstructorContent';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Constructor
 */
export const GetConstructorLatestContentContentType = '' as const;
export type GetConstructorLatestContentRequest = void;
export type GetConstructorLatestContentResponses = LinkCommonErrorResponses & {
    /**
     * @description Latest constructor content
     */
    '200': {
        'application/json': SchemaConstructorContent;
    };
};
export type GetConstructorLatestContentResponseSuccess =
    GetConstructorLatestContentResponses['200']['application/json'];
export type GetConstructorLatestContentSearchParams = undefined;
export type GetConstructorLatestContentPathParameters = undefined;
export const GetConstructorLatestContentUrl = '/constructor/versions/latest/content' as const;
export const GetConstructorLatestContentMethod = 'GET' as const;
export const getGetConstructorLatestContentUrl = (_params?: GetConstructorLatestContentPathParameters) =>
    GetConstructorLatestContentUrl;
